import { css } from '@emotion/react';
import { black, gray1, gray2, hexToRgbaString } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

const AICommonStyles = css`
  .text-ai-color {
    background-image: linear-gradient(48.41deg, #60f3ab, #00ccbc, #009ac0);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .option {
    border: double 2px transparent;
    border-radius: ${quarterSpacing}px;

    .title-text {
      color: ${gray1};
    }

    .description-text {
      color: ${gray2};
    }

    &.selected {
      position: relative;
      background-color: ${hexToRgbaString('#00CCBC', 0.05)};

      .title-text, .description-text {
        color: ${black};
      }
      ::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: ${quarterSpacing}px;
        background: linear-gradient(48.41deg, #60f3ab, #00ccbc, #009ac0);
        padding: 2px; /* Adjust to match the border width */
        -webkit-mask:
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask:
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        -webkit-mask-composite: destination-out;
        mask-composite: exclude; /* Make the center part transparent */
        z-index: -1;
      }
    }

    &:hover {
      background-color: ${hexToRgbaString('#00CCBC', 0.05)};

      .title-text, .description-text {
        color: ${black};
      }
    }
  }
`;

export default AICommonStyles;
